module.exports = __webpack_public_path__ + "static/img/17.78f94e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/17.jpg
// module id = ez+c
// module chunks = 0